<template>
  <div>
    <div class="streaming-page">
      <loader v-if="loading" />
      <div @click="handleFullscreen" class="pivo-full-screen">
        <img src="../assets/fullscreen.png" alt="fullscreen" />
      </div>
      <div class="stream-video-wrapper" ref="stream" id="stream">
        <div class="pivo-logo-stream">
          <img src="../assets/pivo.png" alt="logo" />
        </div>
        <div @click="handleFullscreen" class="pivo-full-screen">
          <img
            v-if="isFullScreen"
            src="../assets/fullscreen_exit.png"
            alt="fullscreen_exit"
          />
        </div>
        <video id="streaming-video" autoplay playsinline muted></video>
        <div class="stop-button">
          <button @click="endSessionListening()">
            <img src="../assets/qr_back.png" alt="qr_back" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import io from "socket.io-client";
  import Store from "@/utils/store";
  import Loader from "@/components/Loader";

  export default {
    data() {
      return {
        stream: null,
        loading: true,
        peerConn: null,
        remoteStream: null,
        isFullScreen: false,
        io: null,
        iceConfig: {},
        data: null,
        tracks: null,
        otherBrowserUsed: false,
      };
    },
    components: { Loader },

    mounted() {
      this.connnect();
      document
        .getElementById("stream")
        .addEventListener("fullscreenchange", () => {
          if (document.fullscreenElement) {
            this.isFullScreen = true;
          } else {
            this.isFullScreen = false;
          }
        });
    },

    methods: {
      connnect() {
        if (this.otherBrowserUsed) return;
        const data = Store.getSessionData();
        this.data = data;
        console.log("data ", data);
        const namespace = "cast";
        const ws2URL = `${data.domain}/${namespace}?roomName=${data.roomId}&&token=${data.accessToken}`;

        this.io = io(ws2URL, {
          transports: ["websocket"],
          // forceNew: true,
        });

        this.io.on("connect", () => {
          console.log("******** second ws connection ********");

          if (this.otherBrowserUsed) return;
          this.io.emit(
            "joinRoom",
            { roomName: data.roomId, deviceType: "browser" },
            (iceData) => {
              this.iceConfig = iceData.iceServers;
              // console.log('ice-servers from -- ', data);
              console.log("iceData   >>> ", iceData);
            }
          );
          // end of io.on
        });

        this.io.on("rtc", async (data) => {
          console.log("rtc >>>> ", data);
          if (this.peerConn) {
            if (this.peerConn.remoteStream) return;
            this.handleSignalingData(data);
          }
        });

        this.io.on("notify", async (data) => {
          console.log("notify keldi -- ", data);
          switch (data.msg) {
            case "JOIN_USER":
              if (data.client.deviceType === "browser") {
                // New browser joined
                this.otherBrowserUsed = true;
                const video = this.$el.querySelector("#streaming-video");
                if (video) video.srcObject = undefined;
              }
              break;

            case "READY_TO_ACCEPT_OFFER":
              console.log(".../.....READY_TO_ACCEPT_OFFER");
              // await createAndSendOffer(roomName);
              this.startRTC();
              break;

            case "USER_DISCONNECTED":
              console.log("USER_DISCONNECTED");
              console.log(data);
              this.cleanAll();
              this.$router.push({ name: "qrcode" });

              break;

            case "ROOM_DELETED":
            case "LEAVE_USER":
              this.cleanAll();
              this.$router.push({ name: "qrcode" });
              break;

            default:
              break;
          }
        });

        this.io.on("error", (error) => {
          console.log("error: ", error);
          this.endSessionListening();
        });

        this.io.on("connect_error", (error) => {
          console.log("connect_error: ", error);
        });

        this.io.on("connect_failed", (error) => {
          console.log("connect_failed: ", error);
        });
      },

      cleanAll() {
        if (this.tracks && this.tracks.length > 0) {
          this.tracks[0].stop();
        }

        if (this.io) {
          this.io.close();
        }

        if (this.peerConn) {
          this.peerConn.close();
        }

        Store.clear();
      },

      async startRTC() {
        if (this.peerConn) {
          // Already connected
          return;
        }
        console.log("****** RTC Connection started ******", this.iceConfig);
        const peerConn = new RTCPeerConnection(this.iceConfig);
        this.peerConn = peerConn;
        // const stream = new MediaStream();
        // const stream = await navigator.mediaDevices.getUserMedia({
        //   video: true,
        //   audio: false,
        // });

        // for (const track of stream.getVideoTracks()) {
        //   this.peerConn.addTrack(track, stream);
        // }

        // try {
        //   stream.getTracks().forEach((track) => (track.enabled = false));
        // } catch (error) {
        //   console.error("error toggle media -- ", error);
        // }
        // const tracks = stream.getTracks();
        // this.tracks = tracks;

        await this.eventHandlers();
        await this.handleOffer();
      },

      endSessionListening() {
        this.cleanAll();
        this.io = null;
        this.$router.push({ name: "qrcode" });
      },

      startDisplaying() {
        const video = this.$el.querySelector("#streaming-video");
        setTimeout(() => {
          console.log("video", video);
          console.log(this.remoteStream);
          video.srcObject = this.remoteStream;
          video.muted = true;

          this.loading = false;
        }, 0);
      },

      handleFullscreen() {
        const docElm = this.$refs.stream;
        const isInFullScreen =
          (document.fullscreenElement && document.fullscreenElement !== null) ||
          (document.webkitFullscreenElement &&
            document.webkitFullscreenElement !== null) ||
          (document.mozFullScreenElement &&
            document.mozFullScreenElement !== null) ||
          (document.msFullscreenElement &&
            document.msFullscreenElement !== null);
        if (isInFullScreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          this.isFullScreen = false;
        } else {
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen();
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen();
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen();
          } else if (docElm.msRequestFullscreen) {
            docElm.msRequestFullscreen();
          }
          this.isFullScreen = true;
        }
      },

      isConnecting() {
        return this.peerConn && this.peerConn.connectionState === "connecting";
      },

      isConnected() {
        return (
          this.peerConn &&
          this.peerConn.connectionState === "connected" &&
          (this.peerConn.iceConnectionState === "completed" ||
            this.peerConn.iceConnectionState === "connected")
        );
      },

      async handleSignalingData(update) {
        console.log("[rtc data : ", update);
        try {
          if (update.type === "candidate") {
            try {
              await this.handleCandidate(update.data);
              return;
            } catch (error) {
              if (!window.ignoreOffer) throw error;
            }
          }
          if (this.isConnecting() && this.isConnected()) return;

          if (update.type === "answer") {
            window.isNegotiating = true;

            await this.handleAnswer(update.data);
          }
        } catch (error) {
          console.warn(
            "error Socket RTC update -----",
            error,
            window.rtcConnection
          );
        }

        return;
      },

      handleCandidate(candidateInitMsg) {
        try {
          const candidate = new RTCIceCandidate(candidateInitMsg);
          this.peerConn.addIceCandidate(candidate);
        } catch (err) {
          console.error("handleCandidate error - ", err);
        }

        return;
      },

      handleAnswer(answer) {
        console.log("[setRemoteDescription] answer received");
        try {
          this.peerConn.setRemoteDescription(new RTCSessionDescription(answer));
        } catch (err) {
          console.error("handleAnswer error - ", err);
        }
      },

      async handleOffer() {
        console.log("[setRemoteDescription] offer created and sent");
        try {
          this.makingOffer = true;
          const offer = await this.peerConn.createOffer({
            offerToReceiveVideo: true,
          });
          await this.peerConn.setLocalDescription(offer);
          console.log("() ==> local offer ", offer);

          this.io.emit("rtc", {
            type: "offer",
            roomName: this.data.roomId,
            data: offer,
          });
        } catch (err) {
          console.error(err);
        } finally {
          this.makingOffer = false;
        }
      },

      async eventHandlers() {
        console.log(">>>>>>> eventHandlers");
        if (!this.peerConn) return;

        this.ignoreOffer = false;

        // this is most important event
        this.peerConn.ontrack = ({ streams, track }) => {
          console.log("REMOTE ONTRACK: ", streams, track);
          // if (track.kind === 'video') {
          //   store.commit('rtc/setRemoteVideoEnabled', track.enabled);
          // } else if (track.kind === 'audio') {
          //   store.commit('rtc/setRemoteAudioEnabled', track.enabled);
          // }
          // store.commit('rtc/setRemoteStream', streams[0]);
          this.remoteStream = streams[0];
          this.remoteStreamAvailable = true;
          this.startDisplaying();
        };

        this.peerConn.onconnectionstatechange = () => {
          console.log(
            "[rtc] onConnectionstatechange -- ",
            this.peerConn.connectionState
          );
        };

        // when I receive iceCandidate I need to send back iceCandidate also
        this.peerConn.onicecandidate = (e) => {
          console.log(
            "onicecandidate: ",
            this.peerConn.iceGatheringState,
            e.candidate
          );

          if (e.candidate) {
            this.io.emit("rtc", {
              roomName: this.data.roomId,
              type: "candidate",
              data: e.candidate,
            });
          }
        };

        /**
         * Most commonly, the negotiationneeded event is fired after a send track
         * is added to the RTCPeerConnection. If the session is modified in a manner
         * that requires negotiation while a negotiation is already in progress,
         * no negotiationneeded event will fire until negotiation completes,
         * and only then if negotiation is still needed.
         */
        this.peerConn.onnegotiationneeded = async (e) => {
          console.log("onnegotiationneeded: ", e);

          try {
            this.makingOffer = true;
            const offer = await this.peerConn.createOffer();
            await this.peerConn.setLocalDescription(offer);
            console.log("() ==> local offer ", offer);

            this.io.emit("rtc", {
              type: "offer",
              roomName: this.data.roomId,
              data: offer,
            });
          } catch (err) {
            console.error(err);
          } finally {
            this.makingOffer = false;
          }
        };

        this.peerConn.onicecandidateerror = (event) => {
          console.info("*?* onicecandidateerror", event);
        };

        this.peerConn.onicegatheringstatechange = () => {
          console.info("--> onicegatheringstatechange");
          console.info("state: ", this.peerConn.iceGatheringState);
        };

        this.peerConn.onsignalingstatechange = (event) => {
          console.info(
            "-- onsignalingstatechange",
            this.peerConn.signalingState,
            event
          );

          switch (this.peerConn.signalingState) {
            case "closed":
              console.info(
                "-- onsignalingstatechange",
                this.peerConn.signalingState
              );
              break;

            default:
              break;
          }

          this.isNegotiating = this.peerConn.signalingState !== "stable";
        };

        this.peerConn.onstatsended = (event) => {
          console.info("-- onstatsended", event);
        };

        this.peerConn.oniceconnectionstatechange = async (event) => {
          if (!this.peerConn) {
            console.warn("peerConn is null");
            return;
          }
          console.info(
            "iceconnectionstatechange-- ",
            this.peerConn.iceConnectionState,
            event
          );

          switch (this.peerConn.iceConnectionState) {
            case "failed":
              this.peerConn.restartIce();
              this.cleanAll();
              this.$router.push({
                name: "error",
                params: {
                  title: "Connection Failed",
                  secondaryText:
                    "Failed connection to the mobile app. Click button to try again.",
                  tryButton: true,
                },
              });
              break;

            case "closed":
              break;

            case "disconnected":
              this.cleanAll();
              if (this.$route.name !== "qrcode") {
                this.$router.push({ name: "qrcode" });
              }
              break;

            default:
              break;
          }
        };
        // TODO: when I move calling createAndSendOffer function inside of
        // negotiaitionNeeded listener cam on/off not working
        // await this.createAndSendOffer();
      },
    },
  };
</script>

<style lang="css">
  .streaming-page {
    position: relative;
    width: 100%;
    height: 100vh;
    background: #333;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pivo-logo-stream {
    z-index: 100;
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .pivo-logo-stream img {
    height: 35px;
  }

  .pivo-full-screen {
    z-index: 100;
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .pivo-full-screen img {
    height: 25px;
    cursor: pointer;
  }

  .live-loading {
    position: absolute;
    width: 20%;
    height: 20%;
    color: rgb(224, 15, 15);
  }

  .loading-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .stream-video-wrapper {
    width: 100%;
    height: 100%;
    max-height: 100vh;
    margin: 0;
    padding: 0;
  }

  #streaming-video {
    width: 95%;
    max-height: 100vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .live-record-effect {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgb(224, 15, 15);
    animation: blinker 1.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate;
  }

  @keyframes blinker {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .stop-button {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  .stop-button button {
    display: inline-block;
    border: none;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: none;
    color: #dcdfe6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 6px 10px;
    font-size: 14px;
  }

  .stop-button button img {
    height: 32px;
  }

  #streamingvideo::-webkit-media-controls {
    display: none !important;
  }

  video::-webkit-media-controls-enclosure {
    display: none !important;
  }
</style>
